module.exports = __webpack_public_path__ + "static/media/lauren-cohen.f3e8f341.jpg";